import { defineComponent as _defineComponent } from 'vue'
import Utils from '@/assets/js/utils/Utils';
import { computed } from 'vue';
import Formatter from '@/assets/js/utils/Formatter';


export default /*#__PURE__*/_defineComponent({
  __name: 'AppFooter',
  setup(__props) {

const APP_IMPRESSUM_URL = process.env.VUE_APP_IMPRESSUM_URL ?? '';
const APP_PRIVACY_URL = process.env.VUE_APP_PRIVACY_URL ?? '';

const build = computed<string>(() => {
    const buildTime = process.env.VUE_APP_BUILD_TIME_UTC;
    if (!buildTime) {
        return '';
    }

    const convertedBuildTime = Utils.convertUTCStringToLocalDate(buildTime);
    return Formatter.formatDate(convertedBuildTime, 'dd.MM.yyyy hh:mm');
});

const version = computed<string>(() => {
    const packageJson = require('../../../package.json');
    return packageJson.version.replace(/.[0-9]*$/, '');
});

return { __sfc: true,APP_IMPRESSUM_URL, APP_PRIVACY_URL, build, version }
}

})